import { FC, ReactNode, useContext } from 'react'
import SvgDownload from '../components/icons/Download'
import './UploadFormDrop.scss'
import { AppContext } from '../AppContext'
import classNames from 'classnames'

interface Props {
  caption: ReactNode
}

export const UploadFormDrop: FC<Props> = ({ caption }) => {
  const { dragging } = useContext(AppContext)

  return (
    <div
      className={classNames('UploadFormDrop', {
        '-dragging': dragging,
      })}
    >
      <SvgDownload className="icon" />

      <div className="caption">{caption}</div>

      <div className="types">Support for most audio formats.</div>
    </div>
  )
}
